import React from "react";

export const Privacy = () => {
  return (
    <div className="mx-auto max-w-4xl rounded-lg bg-white p-6 shadow-md">
      <h1 className="mb-4 text-2xl font-bold">Privacy Policy</h1>
      <p className="mb-4">
        Thank you for using Preclinify! This Privacy Policy provides
        Preclinify’s (“we” or “our”) policies and procedures for collecting,
        using, and disclosing your information. Users can access our website and
        services (the “Services”) through our website{" "}
        <a href="http://Preclinify.com" className="text-blue-500 underline">
          http://Preclinify.com
        </a>
        , applications on Devices, through APIs, and through third-parties. A
        “Device” is any computer used to access our Service, including without
        limitation a desktop, laptop, mobile phone, tablet, or other consumer
        electronic device. This Privacy Policy governs your access of our
        Services, regardless of how you access it, and by using our Services you
        consent to the collection, transfer, processing, storage, disclosure and
        other uses described in this Privacy Policy. All of the different forms
        of data, content, and information described below are collectively
        referred to as "information." If you have questions or concerns
        regarding this Privacy Policy, please contact us by e-mail.
      </p>

      <h2 className="mb-2 text-xl font-semibold">
        1. Information We Collect & How We Use It
      </h2>
      <p className="mb-4">
        Our primary purpose in collecting personal information is to provide you
        with a safe, smooth, efficient, and customized experience. This allows
        us to provide Services that most likely meet your needs, and to
        customize our Services to make your experience safer and easier. We only
        collect personal information about you that we consider necessary for
        achieving this purpose. In general, you can browse our Services without
        telling us who you are or revealing any personal information about
        yourself. Once you give us your personal information, you are no longer
        anonymous to us.
      </p>

      <h2 className="mb-2 text-xl font-semibold">
        2. Information You Choose to Share
      </h2>
      <p className="mb-4">
        In order to use some of our Services, you must first complete the
        registration form and create a username and password. During
        registration, you are required to give truthful contact information
        (such as a valid email address) in accordance with our Terms of Service.
        We use this information to contact you about Services in which you have
        expressed interest. Your information also includes the information you
        choose to share on our website, such as when you post a question or add
        notes in a module. We may also receive information about you from the
        modules, exercises, and other services you use that we provide on the
        Websites.
      </p>

      <h2 className="mb-2 text-xl font-semibold">
        3. Information We Collect To Respond To Your Choices and Requests
      </h2>
      <h3 className="mb-1 font-semibold">a) Orders</h3>
      <p className="mb-4">
        If you purchase a product or service from us, we request certain
        personally identifiable information from you on our order form. You must
        provide contact information (such as your email address) and financial
        information (such as a credit card number and expiration date). We use
        this information for billing purposes and to fill your orders. If we
        have trouble processing an order, we will use this information to
        contact you.
      </p>
      <h3 className="mb-1 font-semibold">b) Surveys or Contests</h3>
      <p className="mb-4">
        We may provide you the opportunity to participate in contests or surveys
        on our website. If you participate, we will request certain personally
        identifiable information from you. The requested information typically
        includes contact information (such as name and shipping address) and
        demographic information. We use this information to notify contest
        winners and award prizes, to monitor traffic on our website, or to
        personalize our services (in the case of anonymous information collected
        in surveys).
      </p>
      <h3 className="mb-1 font-semibold">c) Referral Service</h3>
      <p className="mb-4">
        If you choose to use our referral service to tell a friend about our
        Website, we will ask you for your friend’s name and email address. We
        will automatically send your friend a one-time email inviting him or her
        to visit the Website. Preclinify Technologies Ltd. will store this
        information for the sole purpose of sending this one-time email and
        tracking the success of our referral program. Your friend may contact us
        via email to request that we remove this information from our database.
      </p>
      <h3 className="mb-1 font-semibold">d) Log files</h3>
      <p className="mb-4">
        Like many Websites, we automatically gather certain information about
        our Website traffic and store it in log files. This information includes
        Internet protocol (IP) addresses, browser type, Internet service
        provider (ISP), referring/exit pages, operating system, date/time stamp,
        and clickstream data. We use this information, which does not identify
        individual users, to analyze trends, to administer the Website, to track
        users’ movements around the Website and to gather demographic
        information about our user base. We do not link this automatically
        collected data to personally identifiable information.
      </p>
      <h3 className="mb-1 font-semibold">e) Cookies</h3>
      <p className="mb-4">
        A cookie is a small text file that is stored on a user’s computer for
        record-keeping purposes. We may use cookies on this Website. As noted
        above, we do not link the information we store in cookies to any
        personally identifiable information you submit while on our Website. Our
        site uses cookies dropped by us or third parties for a variety of
        purposes including to operate and personalize the website. Cookies may
        also be used to track how you use the site to target ads to you on other
        websites.
      </p>
      <h3 className="mb-1 font-semibold">f) Special Offers & Updates</h3>
      <p className="mb-4">
        We may occasionally send you information on products, services, special
        deals, and promotions. We may provide a registration page on which you
        can sign up to receive such emails from us. Out of respect for your
        privacy, we present the option not to receive these types of
        communications. Please see the "Choice and Opt-out."
      </p>
      <h3 className="mb-1 font-semibold">g) Service-Related Announcements</h3>
      <p className="mb-4">
        We will send you strictly service-related announcements on rare
        occasions when it is necessary to do so. For instance, if our service is
        temporarily suspended for maintenance, we might send you an email.
        Generally, you may not opt-out of these communications, which are not
        promotional in nature. If you do not wish to receive them, you have the
        option to deactivate your account.
      </p>
      <h3 className="mb-1 font-semibold">h) Customer Service</h3>
      <p className="mb-4">
        Based upon the personally identifiable information you provide us, we
        will send you a welcoming email to verify your username and password. We
        will communicate with you in response to your inquiries, to provide the
        services you request, and to manage your account. We will communicate
        with you by email or telephone, in accordance with your wishes.
      </p>
      <h3 className="mb-1 font-semibold">i) Profile</h3>
      <p className="mb-4">
        We may store information that we collect through cookies, log files,
        and/or third party sources to create a “profile” of your preferences. We
        do not tie your personally identifiable information, or your purchasing
        history, to information in the profile, in order to provide tailored
        promotions and marketing offers and to improve the content of the
        Website for you. We do not share your profile with other third parties.
      </p>

      <h2 className="mb-2 text-xl font-semibold">
        4. Conditions Under Which We Share Information
      </h2>
      <h3 className="mb-1 font-semibold">
        a) Aggregate Information (Non-Personally Identifiable)
      </h3>
      <p className="mb-4">
        We may share aggregated demographic information about our user base with
        our partners. This information does not identify individual users. We do
        not link aggregate user data with personally identifiable information.
        In addition, data may be aggregated regarding assessment of your
        performance based on various measures to create generalized data
        regarding use of our platform. We may use and publicize such aggregate
        information on any basis that does not identify you, without your
        consent.
      </p>
      <h3 className="mb-1 font-semibold">
        b) Personally Identifiable Information
      </h3>
      <p className="mb-4">
        Except as discussed in this Privacy Policy, we do not share personally
        identifiable information with third parties. In accordance with our
        Terms of Service, we may share your personally identifiable information
        with an educational institution under certain circumstances.
      </p>
      <h3 className="mb-1 font-semibold">c) Agents</h3>
      <p className="mb-4">
        We use a credit card processing company to bill you for our Services.
        These companies do not retain, share, store or use personally
        identifiable information for any other purposes.
      </p>
      <h3 className="mb-1 font-semibold">d) Service Providers</h3>
      <p className="mb-4">
        We use other third parties to provide mapping solutions on the Website.
        When you sign up for any of our services, we will share location that
        you enter as necessary for the third party to provide that service.
      </p>
      <h3 className="mb-1 font-semibold">e) Legal Disclaimer</h3>
      <p className="mb-4">
        We reserve the right to disclose your personally identifiable
        information as required by law and when we believe that disclosure is
        necessary to protect our rights; to comply with a judicial proceeding,
        court order, or legal process served on us or the Website; or in
        connection with an actual or proposed corporate transaction or
        insolvency proceeding involving all or part of the business or asset to
        which the information pertains.
      </p>
      <h3 className="mb-1 font-semibold">f) Choice/Opt-out</h3>
      <p className="mb-4">
        We provide you the opportunity to ‘opt-out’ of having your personally
        identifiable information used for certain purposes, when we ask for this
        information. For example, if you purchase one of our Services but do not
        wish to receive any additional marketing material from us, you can
        indicate your preference in your “notification preferences.” If you no
        longer wish to receive our newsletter and promotional communications, if
        any, you may opt-out of receiving them by following the instructions
        included in each newsletter or communication or by emailing us.
      </p>
      <h3 className="mb-1 font-semibold">g) Links to Other Websites</h3>
      <p className="mb-4">
        The Website contains links to other sites that are not owned or
        controlled by Preclinify Technologies Ltd. Please be aware that we are
        not responsible for the privacy policies of such other sites. We
        encourage you to be aware when you leave our website and to read the
        privacy policies of each and every website that collects personally
        identifiable information. This Privacy Policy applies only to
        information collected through our Services.
      </p>
      <h3 className="mb-1 font-semibold">
        h) Access to Personally Identifiable Information
      </h3>
      <p className="mb-4">
        If your personally identifiable information changes, or if you no longer
        desire our service, you may correct, update, delete or deactivate it by
        making the change on our member information page or by emailing us or by
        contacting us by telephone.
      </p>
      <h3 className="mb-1 font-semibold">i) Security</h3>
      <p className="mb-4">
        The security of your personal information is important to us. When you
        enter sensitive information (such as your credit card number) on our
        registration or order forms, we encrypt that information using secure
        socket layer technology (SSL). We follow generally accepted industry
        standards to protect the personal information submitted to us, both
        during transmission and once we receive it. No method of transmission
        over the Internet, or method of electronic storage, is 100% secure,
        however. Therefore, while we strive to use commercially acceptable means
        to protect your personal information, we cannot guarantee its absolute
        security. If you have any questions about security on our Website, you
        can email us.
      </p>
      <h3 className="mb-1 font-semibold">j) Children</h3>
      <p className="mb-4">
        Our Website is not directed to people under 13 years of age. If you
        become aware that your child has provided us with personal information
        without your consent, please contact us. We do not knowingly collect
        Personal Information from children under 13. If we become aware that a
        child under 13 has provided us with Personal Information, we take steps
        to remove that information and terminate the applicable account.
      </p>
      <h3 className="mb-1 font-semibold">k) Terms of Service</h3>
      <p className="mb-4">
        Please also visit our Terms of Service which establish the use,
        disclaimers, and limitations of liability governing the use of our
        Services.
      </p>
      <h2 className="mb-2 text-xl font-semibold">
        5. Changes to this Privacy Policy
      </h2>
      <p>
        If we decide to change our privacy policy, we will post changes to this
        privacy policy and other places we deem appropriate so that you are
        aware of what information we collect, how we use it, and under what
        circumstances, if any, we disclose it. We reserve the right to modify
        this privacy policy at any time, so please review it frequently.
      </p>
    </div>
  );
};
